import { RichContent } from '@corratech/pylot-rich-content'
import React, { memo, ReactElement } from 'react'
import s from '@pagestyles/PDP.module.scss'
import { useTranslation } from 'next-i18next'
import st from './ProductInfo.module.scss'
import cn from 'classnames'
import { Accordion } from '@corratech/pylot-ui'
import { Maybe } from '@pylot-data/pylotschema'

type ProductInfoProps = {
    description?: {
        html?: string
    }
    assemblyCare?: string
    whatsInBox?: string
    faq?: string
    descriptionTitle?: string
    whatsInBoxTitle?: string
    assemblyCareTitle?: string
    faqTitle?: string
    returnPolicy?: Maybe<string>
    returnPolicyTitle?: Maybe<string>
}

const ProductInfoComponent = ({
    description = {},
    assemblyCare,
    whatsInBox,
    faq,
    descriptionTitle,
    whatsInBoxTitle,
    assemblyCareTitle,
    faqTitle,
    returnPolicy,
    returnPolicyTitle
}: ProductInfoProps): ReactElement | null => {
    const { html } = description
    const { t } = useTranslation(['common'])

    if (!html && !assemblyCare && !whatsInBox && !faq && !returnPolicy) {
        return null
    }

    let tabs = [
        {
            title: descriptionTitle ?? t('Overview'),
            content: html
        },
        {
            title: whatsInBoxTitle ?? t('What’s in the Box'),
            content: whatsInBox
        },
        {
            title: returnPolicyTitle ?? t('Return Policy'),
            content: returnPolicy
        },
        {
            title: assemblyCareTitle ?? t('Assembly and Care'),
            content: assemblyCare
        },
        {
            title: faqTitle ?? t('FAQ'),
            content: faq
        }
    ]

    tabs = tabs.filter((tab, index) => {
        if (tab.content) return true
        tabs.splice(index, 1)
        return false
    })

    const contents = tabs.map((tab, index) => ({
        id: (index + 1).toString(),
        Title: function AccordionTitle() {
            return <div className={st['accordian-title']}>{tab.title}</div>
        },
        Content: function AccordionContent() {
            return <RichContent html={tab.content} />
        },
        initialState: false
    }))

    return (
        <div className={cn(s['pdp-info-wrap'], st['pdp-info-wrap'])}>
            <Accordion contents={contents} />
        </div>
    )
}

export const ProductInfo = memo(ProductInfoComponent)
